import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileRestrictions, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { DomSanitizer } from "@angular/platform-browser";
import Swal from 'sweetalert2';
import { IPhotoUploader } from 'bi-interfaces';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bi-photo-uploader',
  templateUrl: './bi-photo-uploader.component.html',
  styleUrls: ['./bi-photo-uploader.component.scss']
})
export class BiPhotoUploaderComponent implements IPhotoUploader {

  @ViewChild('photoUploader') photoUploader!: UploadComponent;

  @Output() uploadPhotoClicked: EventEmitter<any> = new EventEmitter();
  @Output() selectPhotoClicked: EventEmitter<any> = new EventEmitter();
  @Output() completeUpload: EventEmitter<any> = new EventEmitter();
  @Output() clearPhotoClicked: EventEmitter<any> = new EventEmitter();

  @Input() LabelName!: string;
  @Input() BindingProperty!: FormControl;
  @Input() MainFormGroup!: FormGroup;
  @Input() UploadRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", "png", ".jpeg", "gif"],
    maxFileSize: 2097152,
  };

  @Input() ClearBtnDisabled!: boolean;
  @Input() UploadBtnDisabled!: boolean;

  @Input() AutoUpload!: boolean;
  @Input() SaveUrl!: any;

  public previewSrc: string | any = '';
  public invalidImage!: boolean;
  public src = `data:image/png;base64,`;

  constructor(public sanitizer: DomSanitizer,
    private translateService: TranslateService,
) {}

  public clearPhoto() {
    this.previewSrc = null;
    this.photoUploader.clearFiles();
    this.clearPhotoClicked.emit(null);
  }

  public uploadPhoto(event: any) {
    this.BindingProperty.patchValue(
      this.previewSrc.split(",")[1]
    );
    this.previewSrc = null;
    this.uploadPhotoClicked.emit(null);
  }

  public selectPhoto(event: SelectEvent) {
    if (event?.files?.length > 0)
      this.photoUploader.clearFiles();
    if (!event.files[0].validationErrors) {
      let file: any = event.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.invalidImage = false;
        this.previewSrc = e.target.result;
      };
      reader.readAsDataURL(file.rawFile);
    } else {
      this.invalidImage = true;
      // Check if specific validation errors exist and emit appropriate error messages
      if (event.files[0].validationErrors.includes('invalidMaxFileSize')) {
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant('Wrong File Size'),
          text: this.translateService.instant('Image needs to be smaller than 2MB')
        });
      } else if (event.files[0].validationErrors.includes('invalidFileExtension')) {
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant('Wrong File Extension'),
          text: this.translateService.instant('Image needs to be JPG, PNG, JPEG, GIF'),
        });
      }
    }
    this.selectPhotoClicked.emit(null);
  }

  public complete() {
    this.photoUploader.clearFiles();
    this.completeUpload.emit(null);
  }
}
